import styled from '@mui/material/styles/styled';

export const ContentContainer = styled('main')(() => ({
    p: 2,
    pt: 3,
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
}));
